// extracted by mini-css-extract-plugin
export default {"inputInvalid":"SimpleSelect_inputInvalid__ztl4u","input":"SimpleSelect_input__7EGgb","disabled":"SimpleSelect_disabled__dOt2L"};